// Lucide icon: utensils (https://lucide.dev/icons/utensils)
import { Utensils } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconMeals = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Utensils />
    </IconComponentStyled>
  )
}
